/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationsFailedDependencyError
 */
export interface NotificationsFailedDependencyError {
    /**
     * 
     * @type {number}
     * @memberof NotificationsFailedDependencyError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationsFailedDependencyError
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsFailedDependencyError
     */
    message: string;
}

/**
 * Check if a given object implements the NotificationsFailedDependencyError interface.
 */
export function instanceOfNotificationsFailedDependencyError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function NotificationsFailedDependencyErrorFromJSON(json: any): NotificationsFailedDependencyError {
    return NotificationsFailedDependencyErrorFromJSONTyped(json, false);
}

export function NotificationsFailedDependencyErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsFailedDependencyError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': json['message'],
    };
}

export function NotificationsFailedDependencyErrorToJSON(value?: NotificationsFailedDependencyError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': value.message,
    };
}

